<template>
  <v-autocomplete
    v-if="selectType === 'v-autocomplete'"
    flat
    dense
    :outlined="outlined"
    :height="height"
    :menu-props="{ width, height, bottom: true, offsetY: true }"
    :class="[$style.select, 'border-color', { 'base-select--center-icon': centerIcon }]"
    :style="cssVars"
    :append-icon="icon"
    v-bind="{ ...$attrs, ...$props }"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
    @change="$emit('change', $event)"
  />
  <v-select
    v-else
    flat
    dense
    :outlined="outlined"
    :height="height"
    :menu-props="{ width, height, bottom: true, offsetY: true }"
    :class="[$style.select, 'border-color', { 'base-select--center-icon': centerIcon }]"
    :style="cssVars"
    :append-icon="icon"
    v-bind="{ ...$attrs, ...$props }"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
    @change="$emit('change', $event)"
  />
</template>

<script>
/*
 !!TODO: Must be reviewed after the MVP has been introduced.
 !!This file should be refactored if necessary.
 *----------------------------------------------------------*
 !!author: Christopher Bomm
*/
export default {
  name: 'BaseSelect',
  props: {
    size: {
      type: Number,
      default: 24,
    },
    height: {
      type: [String, Number],
      default: 40,
    },
    width: {
      type: [String, Number],
      default: '100%',
    },
    borderColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0.42)',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    centerIcon: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: () => 'mdi-menu-down-outline',
    },
    selectType: {
      type: String,
      default: 'v-select',
    },
  },
  computed: {
    // TODO: Test this for IE11
    cssVars() {
      return {
        '--base-select-height': this.height,
        '--base-select-width': this.width,
        '--base-select-icon-size': this.size + 'px',
        '--base-select-border-color': `var(--${this.borderColor})`,
      }
    },
  },
}
</script>
<style lang="scss" module>
$base-select-fallback-width: 6rem;
$base-select-fallback-height: 2.5rem;

.select {
  min-width: $base-select-fallback-width;
  min-width: var(--base-select-width);
  max-width: 100%; //IE11
  max-width: var(--base-select-width);

  :global(.v-select__selections .v-select__selection--comma) {
    display: flex;
    align-items: center;
    height: $base-select-fallback-height;
    height: var(--base-select-height);
  }

  :global(.v-select__selection) {
    line-height: 1.5;
    white-space: normal;
  }

  &:global(.border-color.v-text-field > .v-input__control > .v-input__slot::before) {
    border-color: var(--base-select-border-color) !important;
  }

  &:global(.v-text-field--outlined > .v-input__control > .v-input__slot) {
    height: $base-select-fallback-height !important;
    height: var(--base-select-height) !important;
  }

  &:global(.base-select--center-icon.v-text-field.v-text-field .v-input__append-inner) {
    align-items: center;
    height: $base-select-fallback-height;
    height: calc(var(--base-select-height) - 5px);
    margin: 0 !important;
  }

  &:global(.v-text-field.v-text-field .v-input__append-inner .v-icon) {
    font-size: var(--base-select-icon-size);
  }

  &:global(.v-select.v-select--is-menu-active) {
    cursor: pointer;

    pointer-events: none;
  }

  &:global(.theme--light.v-text-field--outlined fieldset),
  :global(.v-select__slot) {
    height: $base-select-fallback-height;
    height: var(--base-select-height);
  }

  :global(.v-list-item--link) {
    height: $base-select-fallback-height;
    height: var(--base-select-height);
    min-height: $base-select-fallback-height;
    min-height: var(--base-select-height);
  }

  :global(.v-input__slot) {
    min-width: $base-select-fallback-width;
    min-width: var(--base-select-width);
    min-height: $base-select-fallback-height;
    min-height: var(--base-select-height);
  }
}
</style>
